module.exports = __webpack_public_path__ + "static/media/imageStep1.dd749ffe.svg";